import { render, staticRenderFns } from "./FormitemWapper.vue?vue&type=template&id=ebb8cbe8&scoped=true&"
import script from "./FormitemWapper.vue?vue&type=script&lang=js&"
export * from "./FormitemWapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb8cbe8",
  null
  
)

export default component.exports